import { create } from 'zustand'

type RefsStore = {
  sidebarWidgetsRef: HTMLDivElement | null
  setSidebarWidgetsRef: (el: HTMLDivElement | null) => void
}

export const useRefsStore = create<RefsStore>(set => ({
  sidebarWidgetsRef: null,
  setSidebarWidgetsRef: el => set({ sidebarWidgetsRef: el })
}))
